/**
 * TipTap Node — Variable inline (chip atomique).
 *
 * Représente une variable dynamique dans un modèle de document.
 * Rendue comme <span data-variable="employee.firstName">Prénom</span>.
 * À la génération PDF côté backend, ces spans sont remplacés par les
 * valeurs résolues (cf utils/documentTemplateRenderer.js).
 *
 * - inline: oui (s'insère dans un paragraphe)
 * - atom: oui (sélection/suppression d'un seul bloc)
 * - selectable: oui
 */

import { Node, mergeAttributes } from '@tiptap/core';

export const VariableNode = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      key: { default: null },
      label: { default: '' },
      color: { default: '#0d9488' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]',
        getAttrs: (el) => ({
          key: el.getAttribute('data-variable'),
          label: el.getAttribute('data-label') || el.innerText || '',
          color: el.getAttribute('data-color') || '#0d9488',
        }),
      },
    ];
  },

  renderHTML({ HTMLAttributes, node }) {
    const { key, label, color } = node.attrs;
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-variable': key,
        'data-label': label,
        'data-color': color,
        class: 'variable-chip',
        style: `display:inline-flex;align-items:center;background:${color}1a;color:${color};border:1px solid ${color}55;border-radius:4px;padding:0 6px;font-size:0.92em;font-weight:500;line-height:1.4;margin:0 2px;white-space:nowrap;`,
      }),
      label || key,
    ];
  },

  addCommands() {
    return {
      insertVariable:
        (attrs) =>
        ({ chain }) => {
          return chain().focus().insertContent({ type: this.name, attrs }).run();
        },
    };
  },
});
